



























































































import {defineComponent, onMounted, useContext, ref, useStore} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import {
  injectStoreList,
  provideStoreList,
  useStoreListMap,
} from '~/composables/useStoreList'

import { Store } from '~/types/store'
import { Coordinate } from '~/types/geo'
import {useAuth} from "~/composables/useAuth";

export default defineComponent({
  name: 'PagesStoreLister',

  setup() {
    provideStoreList()
    const { authed, user } = useAuth()
    const { setBreadcrumbs } = useBreadcrumb()
    // const  $scrollTo  = useContext()
    const {
      loading: storesLoading,
      filteredStores,
      stores,
      initializeStores,
    } = injectStoreList()
    const { zoom, center,markers, focusToCenter } =
      useStoreListMap(filteredStores)
    const { i18n } = useContext()

    setBreadcrumbs([
      {
        label: `${i18n.t('store.branches')}`,
      },
    ])


    const onClickMarker = (store: Store) => {
      // $scrollTo(`#store-${store.id}`, 800, {
      //   container: '#store-list-element',
      //   lazy: false,
      // })
      console.log("onClickMarker called",store)
      setActiveStore(store)
    }
    const activeStore = ref<Store | null>(null)
    const infoWindowPos = ref<Coordinate | null>(null)
    const setActiveStore = (store) => {
      activeStore.value = store.store
      console.log(store.store,"activestore")
      if(store?.position!==undefined)
        infoWindowPos.value = {
          lat: store.position?.lat,
          lng: store.position?.lng,
        }
      console.log(infoWindowPos.value,"infoWindowPos.value")
    }

    const onSelectStore = (storeId: number) => {
      focusToCenter(storeId)
    }

    onMounted(async () => {
      await initializeStores(false, { Source: 'webshop' })
    })

    return {
      storesLoading,
      stores,
      zoom,
      center,
      markers,
      user,
      onSelectStore,
      onClickMarker,
      infoWindowPos,
      activeStore
    }
  },
})
